type Translate = (key: string) => string

export const INVENTORY_EVENT_KIND_LABEL_KEYS = {
  all: 'timeline.filters.eventKind.all',
  movement: 'timeline.filters.eventKind.movement',
  reservation: 'timeline.filters.eventKind.reservation',
} as const

export const INVENTORY_EVENT_TYPE_LABEL_KEYS = {
  all: 'timeline.filters.eventType.all',
  RECEIVE: 'timeline.filters.eventType.RECEIVE',
  COUNT: 'timeline.filters.eventType.COUNT',
  SALE_POS: 'timeline.filters.eventType.SALE_POS',
  RETURN_POS: 'timeline.filters.eventType.RETURN_POS',
  VOID_POS: 'timeline.filters.eventType.VOID_POS',
  TABLE_POS_ADD: 'timeline.filters.eventType.TABLE_POS_ADD',
  TABLE_POS_VOID: 'timeline.filters.eventType.TABLE_POS_VOID',
  RESERVE: 'timeline.filters.eventType.RESERVE',
  RELEASE: 'timeline.filters.eventType.RELEASE',
  COUNT_ADJUST_UP: 'timeline.filters.eventType.COUNT_ADJUST_UP',
  COUNT_ADJUST_DOWN: 'timeline.filters.eventType.COUNT_ADJUST_DOWN',
} as const

export type InventoryEventKind = keyof typeof INVENTORY_EVENT_KIND_LABEL_KEYS
export type InventoryEventType = keyof typeof INVENTORY_EVENT_TYPE_LABEL_KEYS

export const buildInventoryEventKindOptions = (t: Translate) =>
  (
    Object.entries(INVENTORY_EVENT_KIND_LABEL_KEYS) as Array<
      [InventoryEventKind, string]
    >
  ).map(([value, key]) => ({
    value,
    label: t(key),
  }))

export const buildInventoryEventTypeOptions = (t: Translate) =>
  (
    Object.entries(INVENTORY_EVENT_TYPE_LABEL_KEYS) as Array<
      [InventoryEventType, string]
    >
  ).map(([value, key]) => ({
    value,
    label: t(key),
  }))

export const resolveInventoryEventKindLabel = (
  t: Translate,
  value?: string | null,
) => {
  if (!value) return '-'
  const key =
    value in INVENTORY_EVENT_KIND_LABEL_KEYS
      ? INVENTORY_EVENT_KIND_LABEL_KEYS[value as InventoryEventKind]
      : undefined
  return key ? t(key) : value
}

export const resolveInventoryEventTypeLabel = (
  t: Translate,
  value?: string | null,
) => {
  if (!value) return '-'
  const key =
    value in INVENTORY_EVENT_TYPE_LABEL_KEYS
      ? INVENTORY_EVENT_TYPE_LABEL_KEYS[value as InventoryEventType]
      : undefined
  return key ? t(key) : value
}
